import { useEffect, useState } from "react";
import styles from "./App.module.scss";
import finumLogo from "./assets/FinumLogo.svg";
import RechnerForm from "./components/form/RechnerForm";
import LegalNotice from "./components/legalNotice/LegalNotice";
import LocalComponents from "./components/local/LocalComponents";
import OutputTest from "./components/OutputTest";
import DataOverview from "./components/overview/DataOverview";
import GlobalWrapper from "./util/GlobalWrapper";
import { OutputValues } from "./util/types";

const initialState: OutputValues = {
  age: 35,
  age_till: 100,
  age_entry: 67,
  wish_pension: 3500,
  inflation: 0.015,
  performance_savings: 0.05,
  performance_withdrawal: 0.03,
  statutory_pension: 1800,
  statutory_pension_increase: 0.0167,
  ruerup_pension: 10000,
  ruerup_pension_monthly: 50,
  riester_pension: 5000,
  riester_pension_monthly: 20,
  private_pension: 2500,
  private_pension_monthly: 150,
  rent: 450,
  rent_increase: 0.015,
  depot: 90000,
  depot_monthly: 0,
};

function App() {
  const [mode, setMode] = useState<"inline" | "standalone">("standalone");
  const [showContactForm, setShowContactForm] = useState(false);
  useEffect(() => {
    const rootEl = document.getElementById(
      process.env.REACT_APP_ROOT_ELEMENT_ID || "root"
    );
    if (rootEl) {
      if (rootEl.hasAttribute("data-standalone")) {
        setMode("standalone");
      }
      /*
      if (rootEl.hasAttribute("data-contact-form")) {
        setShowContactForm(true);
      }
       */
    }
  }, []);

  const [outputValues, setOutputValues] = useState<OutputValues | undefined>(
    initialState
  );

  const handleLocalComponentsChange = (
    type: string,
    value: string | boolean
  ) => {
    switch (type) {
      case "showContactForm":
        setShowContactForm(value as boolean);
    }
  };

  return (
    <GlobalWrapper>
      <div className={styles.root}>
        <header className={styles.header}>
          {mode === "standalone" && <img src={finumLogo} alt="Finum Logo" />}
        </header>
        <div className={styles.form}>
          <RechnerForm
            onChange={setOutputValues}
            defaultValues={initialState}
          />
          <DataOverview values={outputValues} />
        </div>
        <LegalNotice />

        {showContactForm && (
          <div>
            <form>
              <h2>Kontakt Formular</h2>
            </form>
          </div>
        )}
      </div>
      {process.env.NODE_ENV === "development" && (
        <div className={styles.version}>
          v{process.env.REACT_APP_VERSION} - {mode}
        </div>
      )}
      {process.env.NODE_ENV === "development" && (
        <>
          <LocalComponents
            showContactForm={showContactForm}
            onChange={handleLocalComponentsChange}
          />
          <OutputTest values={outputValues} />
        </>
      )}
    </GlobalWrapper>
  );
}

export default App;
